﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";

const addressSearchAutoCompletes = [];

export function initializeAddressSearch() {
    let searchAddressSelectors = $('[data-search-address]');
    if (searchAddressSelectors.length) {
        searchAddressSelectors.each(function () {
            let self = $(this);
            let autoComplete = new google.maps.places.Autocomplete(this, {
                types: ['geocode'], componentRestrictions: {country: ['gb', 'im', 'gg', 'je', 'ie']}
            });
            autoComplete.elementSelector = self;
            autoComplete.addListener('place_changed', setAddressSearchResult);

        });
    }
}

function setAddressSearchResult() {
    let place = this.getPlace();
    if (!place || !place.address_components || !place.geometry || !place.geometry.location) {
        return;
    }
    let form = this.elementSelector.closest('form');
    let addressComponents = place.address_components;
    let streetNumber = addressComponents.filter(c => c.types.includes('street_number'));
    let addressLine1 = (streetNumber.length ? streetNumber[0].long_name : '');
    if (addressComponents.filter(c => c.types.includes('route')).length) {
        addressLine1 += ' ' + addressComponents.filter(c => c.types.includes('route'))[0].long_name;
    }
    let addressLine2 = addressComponents.filter(c => c.types.includes('administrative_area_level_2')).length ? addressComponents.filter(c => c.types.includes('administrative_area_level_2'))[0].long_name : '';
    let town = addressComponents.filter(c => c.types.includes('postal_town')).length ? addressComponents.filter(c => c.types.includes('postal_town'))[0].long_name : '';
    let county = addressComponents.filter(c => c.types.includes('administrative_area_level_1')).length ? addressComponents.filter(c => c.types.includes('administrative_area_level_1'))[0].long_name : '';
    let postcode = addressComponents.filter(c => c.types.includes('postal_code')).length ? addressComponents.filter(c => c.types.includes('postal_code'))[0].long_name : '';

    form.find('[name="Input.AddressLine1"]').val(addressLine1);
    form.find('[name="Input.AddressLine2"]').val(addressLine2);
    // form.find('[name="Input.AddressLine3"]').val(addressComponents.filter()
    form.find('[name="Input.City"]').val(town);
    form.find('[name="Input.County"]').val(county);
    form.find('[name="Input.Postcode"]').val(postcode);
}
